import { EventRegistrationConnector } from '@/events/pages/event-registration/connector';
import { EventDetailsModal } from '@/events/components/event-details-modal-v2';

export const EventRegistration = EventRegistrationConnector(EventDetailsModal);
